




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import LinesDetails from './LinesDetails.vue';

@Component
export default class LinesDetailsProxy extends Vue {

  modal: any = null;

  public mounted() {
    this.onParamsChange()
  }

  @Watch('$route.params')
  onParamsChange() {

    if(this.modal) {
      this.modal.close();
    }

    this.modal = this.$buefy.modal.open({
      component: LinesDetails,
      props: {
        params: this.$route.params
      },
      onCancel: () => {
        this.$router.back()
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  beforeDestroy() {
    this.modal.close();
  }

}
